var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0003 9C11.1048 9 12.0003 8.10457 12.0003 7C12.0003 5.89543 11.1048 5 10.0003 5C8.89568 5 8.00025 5.89543 8.00025 7C8.00025 8.10457 8.89568 9 10.0003 9Z",
    fill: "#00AF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.458008 7.00004C1.73226 2.94291 5.52256 0 10.0002 0C14.4778 0 18.2681 2.94288 19.5424 6.99996C18.2682 11.0571 14.4778 14 10.0002 14C5.52257 14 1.73228 11.0571 0.458008 7.00004ZM14.0003 7C14.0003 9.20914 12.2094 11 10.0003 11C7.79111 11 6.00025 9.20914 6.00025 7C6.00025 4.79086 7.79111 3 10.0003 3C12.2094 3 14.0003 4.79086 14.0003 7Z",
    fill: "#00AF50"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeGreen);
export default __webpack_public_path__ + "static/media/EyeGreen.37c6c3de18568aedd1c9488e2f893e25.svg";
export { ForwardRef as ReactComponent };